/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorAffiliateItem as ResolvedLabradorAffiliateItem } from 'base/components/labrador/AffiliateItem';

export const LabradorAffiliateItem: typeof ResolvedLabradorAffiliateItem = withLabradorInstanceof((props) => {
    return <ResolvedLabradorAffiliateItem {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorAffiliateItemProps = PropsFromComponent<typeof LabradorAffiliateItem>;
